import { gql } from '@apollo/client';
import {
  GetStudyUnitTitle_StudyUnitFragment,
  GetStudyUnitTitle_ReplicaStudyUnitFragment,
  GetStudyUnitTitle_StudyUnitInstanceFragment,
  GetStudyUnitTitle_StudyUnitInstanceReservationFragment,
  GetStudyUnitTitle_CustomStudyUnitFragment,
} from '@ui/utils/getStudyUnitTitle.generated';

type StudyUnit =
  | GetStudyUnitTitle_StudyUnitFragment
  | GetStudyUnitTitle_ReplicaStudyUnitFragment
  | GetStudyUnitTitle_StudyUnitInstanceFragment
  | GetStudyUnitTitle_StudyUnitInstanceReservationFragment
  | GetStudyUnitTitle_CustomStudyUnitFragment;

export const getStudyUnitTitle = ({
  studyUnit,
  orderPrefix,
  titleOnly = false,
}: {
  studyUnit: StudyUnit;
  orderPrefix?: number | string;
  titleOnly?: boolean;
}) => {
  if (titleOnly) {
    return studyUnit?.title || '';
  }
  if (!studyUnit.__typename) {
    return '';
  }

  if (studyUnit.__typename === 'CustomStudyUnit') {
    return studyUnit.title;
  }

  if (studyUnit.__typename === 'StudyUnitInstance') {
    if (
      studyUnit.gradingUnitCategory === 'BLOCK_ACTIVITY' ||
      studyUnit.gradingUnitCategory === 'BLOCK_STUDY_UNIT'
    ) {
      return studyUnit.title;
    }
  }

  // TODO: nonOptionalTypename
  // @ts-ignore
  const studyUnitTitle = `${studyUnit?.prefixTitle ? `${studyUnit?.prefixTitle} -` : ''} ${
    studyUnit?.title || ''
  }`;

  if (orderPrefix) {
    return `${`${orderPrefix}`.padStart(2, '0')} ${studyUnitTitle}`;
  }

  return studyUnitTitle;
};

gql`
  fragment GetStudyUnitTitle_CustomStudyUnit on CustomStudyUnit {
    id
    category
    gradingUnitCategory
    title
  }
  fragment GetStudyUnitTitle_StudyUnitInstance on StudyUnitInstance {
    id
    gradingUnitCategory
    prefixTitle
    title
  }
  fragment GetStudyUnitTitle_StudyUnit on StudyUnit {
    id
    gradingUnitCategory
    prefixTitle
    title
  }
  fragment GetStudyUnitTitle_ReplicaStudyUnit on ReplicaStudyUnit {
    id
    gradingUnitCategory
    prefixTitle
    title
  }
  fragment GetStudyUnitTitle_StudyUnitInstanceReservation on StudyUnitInstanceReservation {
    prefixTitle
    title
  }
`;

// GetStudyUnitTitle_StudyUnitInstanceReservation prefixTitle
// # 예약피드는 발송되기 전이기때문에 id가 없다
